
import {Component, Vue} from 'vue-property-decorator';
import Api from '@/repository/api';
import {AuthStore} from '@/store/modules/Auth';
import {subscriptionLabels, subscriptionDate} from '@/UI/lib/support';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
@Component({components: {PageTitle, BaseDataForm}})
export default class Subscription extends Vue {
  labels = subscriptionLabels;
  companies: any[] = [];
  history: any[] = [];
  page = 1; total = 0; search = ''; loading = true; error = ''; exporting = false;
  selected: any = null; days = 30; reason = ''; requestId = ''; saving = false; extendError = '';
  get systemAdmin(): boolean { return Boolean((Vue.auth.user() || {}).system_admin); }
  get subscription(): any { return AuthStore.companySubscription; }
  get renewLink(): string {
    return `mailto:${this.subscription.contact_email}?subject=${encodeURIComponent(String(this.$t('Продление подписки Пульт')))}&body=${encodeURIComponent(`${this.subscription.company_name} (ID ${this.subscription.company_id})`)}`;
  }
  date(value: string): string { return subscriptionDate(value, this.$i18n.locale); }
  errorText(error: any): string {
    const body = error.response && error.response.data;
    return body && body.errors ? Object.values(body.errors).flat().join(' ') : (body && (body.message || body.response)) || String(this.$t('Не удалось выполнить запрос. Повторите попытку.'));
  }
  async loadOwner(): Promise<void> {
    this.loading = true; this.error = '';
    try {
      const response = await Api.get('/company/subscription');
      AuthStore.setCompanySubscription(response.data.data); this.history = response.data.history;
    } catch (error) { this.error = this.errorText(error); } finally { this.loading = false; }
  }
  async loadCompanies(page = 1): Promise<void> {
    this.loading = true; this.error = '';
    try {
      const response = await Api.get('/company/subscriptions', {params: {page, search: this.search}});
      this.companies = response.data.data; this.page = response.data.current_page; this.total = response.data.total;
    } catch (error) { this.error = this.errorText(error); } finally { this.loading = false; }
  }
  async openExtend(company: any): Promise<void> {
    this.selected = company; this.days = 30; this.reason = ''; this.extendError = ''; this.history = [];
    const bytes = crypto.getRandomValues(new Uint8Array(16)); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    this.requestId = `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
    try { this.history = (await Api.get('/company/subscription', {params: {company_id: company.id}})).data.history; }
    catch (error) { this.extendError = this.errorText(error); }
  }
  closeExtend(): void { if (!this.saving) this.selected = null; }
  async extend(): Promise<void> {
    if (this.saving || !this.selected) return;
    if (!Number.isInteger(this.days) || this.days < 1 || this.days > 366 || !this.reason.trim()) {
      this.extendError = String(this.$t('Укажите от 1 до 366 дней и основание продления.')); return;
    }
    this.saving = true; this.extendError = '';
    try {
      await Api.post('/company/subscription/extend', {target_company_id: this.selected.id, days: this.days, reason: this.reason.trim(), request_id: this.requestId}, {headers: {'Content-Type': 'application/json'}});
      this.selected = null; this.$message.success(String(this.$t('Подписка продлена')));
      await this.loadCompanies(this.page); window.dispatchEvent(new Event('pult-subscription-changed'));
    } catch (error) { this.extendError = this.errorText(error); } finally { this.saving = false; }
  }
  async exportData(): Promise<void> {
    this.exporting = true; this.error = '';
    try {
      const response = await Api.get('/company/export', {responseType: 'blob'});
      const url = URL.createObjectURL(response.data); const link = document.createElement('a');
      link.href = url; link.download = `pult-company-${this.subscription.company_id}.json`; link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) { this.error = this.errorText(error); } finally { this.exporting = false; }
  }
  created(): void { if (this.systemAdmin) this.loadCompanies(); else this.loadOwner(); }
}
